<template>
  <v-container class="py-6">
    <v-responsive max-width="700" class="mx-auto text-center">
      <h2 class="text-h3 text-lg-h2 mb-6">Login</h2>
    </v-responsive>

    <v-card class="pa-4 mx-auto" max-width="600">
      <v-card-text>
        <v-text-field
          v-model="email"
          label="Email"
          outlined
        ></v-text-field>
       
        <v-text-field
          label="Password"
          v-model="password"
          v-bind:type="showPassword ? 'text' : 'password'"
          v-bind:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showPassword = !showPassword"
          autocomplete="off"
          outlined
          hide-details
        ></v-text-field>

        <v-checkbox dense label="Remember me"></v-checkbox>
        <v-btn
          block
          class="secondary"
          :loading="this.loading"
          @click="login"
          x-large
        >Sign In</v-btn>

        <div class="text-center mt-3 text-body-2">
          <router-link to="/signup">Create new account.</router-link>
        </div>

        <div class="text-center mt-2 text-body-2">
          <router-link to="/reset_password">Forgot your password?</router-link>
        </div>

      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";

export default {
  name: 'Login',

  data: () => ({
    showPassword: false,
    email: '',
    password: '',
    loading: false,
  }),

  methods: {
    login() {
      this.loading = true
      const auth = getAuth();
      signInWithEmailAndPassword(auth, this.email, this.password)
      .then(res => {
        // djangoからアカウント情報を取得してvuexに保存
        const getAccountInfo = async () => {
          await this.axios
          .get(`${process.env.VUE_APP_API_ORIGIN}/account/info`, {
            params: { email : this.email }
          })
          .then(res => {
            this.$store.commit('setEmail', res.data.email)
            this.$store.commit('setStoreId', res.data.store_id)
          })
          .catch(() => {
            alert(e)
          })

          if (this.$route.query.redirect) {
            this.$router.push(this.$route.query.redirect)
          } else {
            this.$router.push({ name: 'Top' })
          }
        }
        getAccountInfo()
      })
      .catch((e) => {
        this.loading = false
        alert('ログイン失敗')
      })
    }
  }
};
</script>